import * as CNF from '@/assets/js/config'

export function plusReady (fn) {
  if (window.plus) {
    fn()
  } else {
    document.addEventListener('plusready', fn, false)
  }
}

export function setCookie (k, o) {
    var v = o instanceof Object ? JSON.stringify(o) : o
    if (CNF.APP_INFO.APP.toLowerCase() == 'web') {
        sessionStorage.setItem(k, v)
    }else{
        sessionStorage.setItem(k, v)
    }
}

export function getCookie (k) {
    var r, re = /^\{.*\}$/
    if (CNF.APP_INFO.APP.toLowerCase() == 'web') {
        r = sessionStorage.getItem(k)
    }else{
        r = sessionStorage.getItem(k)
    }

    if (re.test(r)) r = JSON.parse(r)
    return r
}


export function logout () {
    let u = getCookie('userInfo') || {}
    if (u.token) {
        doRequest('post', '/translate/logout', {token: u.token})
    }
    if (CNF.APP_INFO.APP.toLowerCase() == 'web') {
        sessionStorage.removeItem('userInfo');
        sessionStorage.removeItem('ws');
    }else{
        sessionStorage.removeItem('userInfo');
        sessionStorage.removeItem('ws');
    }
    this.$router.push('login')
    return false
}

import axios from 'axios'
import qs from 'qs'
import {CONF} from "./config";
export async function doRequest(m, u, d) {
    // var tk = sessionStorage.getItem('tk')||''
    // if (!tk||tk=='undefined') {
    //     let res = await axios.get(CNF.API_SERVER+'/index/getToken');
    //     tk = res.data
    //     sessionStorage.setItem('tk', tk)
    // }
    var config = {
        method: m,
        baseURL: CNF.API_SERVER,
        url: u,
        timeout: 8000
    }
    if (!d) var d = {}
    d.tk = sessionStorage.getItem('userToken')
    d.lang = CNF.CONF.LANG
    switch (m) {
        case 'get':
            if (d) config.params = d
            break;
        case 'post':
            if (d) config.data = qs.stringify(d)
            break;
        default:
            return null
            break;
    }
    return axios(config)
}

export function newWS(data){
    var wsTimer = -1;
    var ws = new WebSocket('wss://api.bbx.com/v1/ifspot/realTime');
    ws.onopen = function() {
        ws.send(JSON.stringify(data));
        wsTimer = setInterval(()=>{
            ws.send('{"action":"ping"}')
        }, 1e4)
    };
    ws.onclose = () => {
        clearInterval(wsTimer);
    };
    return ws;
}

